exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".spoiler-warning[data-v-1768627d]{color:red;font-weight:700}.mystery[data-v-1768627d]{font-weight:700}", ""]);

// exports
